import React from "react";
import AsyncFilterDropdown from "./AsyncFilterDropdown";

export default function FiltersPanel({
  months,
  fiscalYear,
  fiscalYearOptions,
  onFiscalYearChange,
  onFiscalYearOpen,
  filters,
  onFilterChange,
  onApply,
  canApply,
  filterError,
  dropdownLoading,
  dropdownErrors,
  divisionOptions,
  stateOptions,
  territoryOptions,
  onDivisionOpen,
  onStateOpen,
  onTerritoryOpen,
  dashboardLoading,
}) {
  return (
    <section className="panel filters-panel">
      <div className="sd-filters-grid">
        {/* ✅ Fiscal Year */}
        <AsyncFilterDropdown
          label="Fiscal Year"
          placeholder="Select Fiscal Year"
          value={fiscalYear}
          options={fiscalYearOptions}
          onOpen={onFiscalYearOpen}
          onSelect={(val) => {
            onFiscalYearChange(val);
            onFilterChange("month", "");
          }}
        />

        {/* ✅ Month */}
        <AsyncFilterDropdown
          label="Month"
          placeholder="Select Month"
          value={filters.month}
          options={months}
          disabled={!fiscalYear}
          onOpen={onFiscalYearOpen}
          onSelect={(val) => onFilterChange("month", val)}
        />

        {/* ✅ Division */}
        <AsyncFilterDropdown
          label="Division"
          placeholder="Select Division"
          value={filters.division}
          options={divisionOptions}
          loading={dropdownLoading?.divisions}
          error={dropdownErrors?.divisions}
          disabled={!filters.month}
          onOpen={onDivisionOpen}
          onSelect={(option) => onFilterChange("division", option)}
          searchable
        />

        {/* ✅ State */}
        <AsyncFilterDropdown
          label="State"
          placeholder="Select State"
          value={filters.state}
          options={stateOptions}
          loading={dropdownLoading?.states}
          error={dropdownErrors?.states}
          disabled={!filters.month || !filters.division}
          onOpen={onStateOpen}
          onSelect={(option) => onFilterChange("state", option)}
          searchable
        />

        {/* ✅ Territory */}
        <AsyncFilterDropdown
          label="Territory / HQ"
          placeholder="Select Territory"
          value={filters.territory}
          options={territoryOptions}
          loading={dropdownLoading?.territories}
          error={dropdownErrors?.territories}
          disabled={!filters.month || !filters.division || !filters.state}
          onOpen={onTerritoryOpen}
          onSelect={(option) => onFilterChange("territory", option)}
          searchable
        />

        {/* ✅ Apply Button */}
        <div className="sd-dropdown sd-dropdown--apply">
          <label className="sd-dropdown__label sd-dropdown__label--hidden">Apply</label>
          <button
            type="button"
            className="sd-apply-button"
            disabled={!canApply || dashboardLoading}
            onClick={onApply}
          >
            {dashboardLoading ? "Loading..." : "Apply"}
          </button>
        </div>
      </div>

      {/* ✅ Error */}
      {filterError && (
        <div className="inline-error">{filterError}</div>
      )}
    </section>
  );
}
